/* eslint-disable react/prop-types */
import Drawer from '@mui/material/Drawer';
import DrawerHeader from './header';

import './style.scss';

/**
 * BasicDrawer component - Renders a Material-UI persistent drawer with custom styling
 * @component
 * @param {Object} props - Component props
 * @param {boolean | string} props.open - Whether the drawer is open or closed
 * @param {Function} props.onClose - Callback function triggered when drawer closes
 * @param {string} props.drawerWidth - CSS class name for the drawer width styling
 * @param {React.ReactNode} props.children - Content to be displayed inside the drawer
 * @returns {JSX.Element} A Material-UI Drawer component with header and children content
 */
export default function BasicDrawer(props) {
  return (
    <div>
      <Drawer
        variant="persistent"
        anchor="right"
        open={props.open}
        onClose={props.onClose}
        classes={{
          root: 'drawerRoot',
          paper: `drawerSnapshtPaper ${props.drawerWidth}`
        }}
      >
        <>
          <DrawerHeader
            title={props.open}
            setOpenDrawer={props.onClose}
          ></DrawerHeader>
          <div className="childrenDrawer">{props.children}</div>
        </>
      </Drawer>
    </div>
  );
}
